import vue from "vue";

const state = {
  list: [],
  update: false
};

const mutations = {
  SET_USER_TASKS_LIST(state, tasksList) {
    vue.set(state, "list", tasksList);
  },
  UPDATE_USER_TASKS_LIST(state, value) {
    vue.set(state, "update", value);
  }
};

export default {
  state,
  mutations
};
